// extracted by mini-css-extract-plugin
export default {"container":"ModalSpinner_container__xd73m"};